module.exports = __webpack_public_path__ + "static/img/03.be2240b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/03.png
// module id = k0Oz
// module chunks = 1